(() => {
  // app/scripts/common/function/ymmUtils.js
  var ELASTICSEARCH_ALL_VALUES_TERMS_SIZE = 1e3;
  var YMM_LEVELS = [
    {
      field: "variants.ymms",
      name: "variants_ymms",
      level: "variant"
    },
    {
      field: "ymms",
      name: "ymms",
      level: "ymms"
    }
  ];
  function cookie(key) {
    return {
      get: function() {
        const item = localStorage.getItem(key);
        if (!item)
          return null;
        const { value, expiry } = JSON.parse(item);
        if (expiry && Date.now() > expiry) {
          this.delete();
          return null;
        }
        return value;
      },
      set: function(value, expiryDays = 1) {
        const expiry = expiryDays ? Date.now() + expiryDays * 24 * 60 * 60 * 1e3 : null;
        const item = JSON.stringify({ value, expiry });
        localStorage.setItem(key, item);
      },
      delete: function() {
        localStorage.removeItem(key);
      }
    };
  }
  function ymmFetch(request) {
    const { appName, shopName } = this.config;
    const URL = `/apps/${appName}/api/elastic/products-${shopName}/_search`;
    const body = JSON.stringify(request);
    return new Promise((resolve, reject) => {
      fetch(URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body
      }).then((res) => res.json()).then((res) => resolve(res)).catch((error) => reject(error));
    });
  }
  function getFitmentTableData(config, variantIds) {
    if (config) {
      const { appName, shopName } = config;
      var FITMENT_TABLE_API = `/apps/${appName}/api/elastic/products-${shopName}/_search`;
      return new Promise((resolve, reject) => {
        fetch(FITMENT_TABLE_API, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            _source: {
              exclude: []
            },
            from: 0,
            size: 100,
            query: {
              bool: {
                must: [
                  {
                    nested: {
                      path: "variants",
                      query: {
                        bool: {
                          should: variantIds.map((id) => ({ match: { "variants.id": id } })),
                          minimum_should_match: 1
                        }
                      }
                    }
                  }
                ]
              }
            }
          })
        }).then((res) => res.json()).then((res) => resolve(res?.hits?.hits)).catch((error) => reject(error));
      });
    }
  }
  function getYMMSelectorQueries(param = "vehicle_type", selected = []) {
    const ymmsSelected = selected;
    let query = {
      bool: {
        should: []
      }
    };
    const aggs = {};
    YMM_LEVELS.forEach((item) => {
      const { name: keyName } = item;
      let subAggs = {};
      const subAggsName = `${item.level}_${param}s`;
      const terms = ymmsSelected.filter((i) => i.value).map((i) => {
        return {
          "term": {
            [`${item.field}.${i.name}`]: i.value
          }
        };
      });
      if (ymmsSelected.length) {
        let obj;
        if (ymmsSelected.length > 1) {
          obj = {
            "filter": {
              "bool": {
                "must": terms
              }
            },
            "aggs": {
              [`${param}s`]: {
                "terms": {
                  "field": `${item.field}.${param}`,
                  "size": 1e3
                }
              }
            }
          };
        } else {
          obj = {
            "filter": terms[0],
            "aggs": {
              [`${param}s`]: {
                "terms": {
                  "field": `${item.field}.${param}`,
                  "size": 1e3
                }
              }
            }
          };
        }
        subAggs[subAggsName] = obj;
        query["bool"]["should"].push(
          {
            "nested": {
              "path": item.field,
              "query": {
                "bool": {
                  "must": terms
                }
              }
            }
          }
        );
      } else {
        subAggs[subAggsName] = {
          "terms": {
            "size": 1e3,
            "field": `${item.field}.${param}`
          }
        };
        query = void 0;
      }
      aggs[`${keyName}${ymmsSelected.length ? "" : "_" + param}`] = {
        nested: {
          path: item.field
        },
        aggs: {
          ...subAggs
        }
      };
    });
    return {
      size: 0,
      query,
      aggs
    };
  }
  function handlelizeYMMSelectorData(data) {
    if (!data)
      return [];
    const bucketsArray = [];
    function findBuckets(obj) {
      for (const key in obj) {
        if (key === "buckets" && Array.isArray(obj[key])) {
          const transformedBuckets = obj[key].map((bucket) => ({
            value: bucket.key.toString()
          }));
          bucketsArray.push(...transformedBuckets);
        } else if (typeof obj[key] === "object" && obj[key] !== null) {
          findBuckets(obj[key]);
        }
      }
    }
    findBuckets(data);
    const uniqueBuckets = Array.from(new Map(bucketsArray.map((item) => [item.value, item])).values());
    uniqueBuckets.sort((a, b) => a.value.localeCompare(b.value));
    return [...new Set(uniqueBuckets)];
  }
  function setYMMSelectorValues(resp) {
    let data = handlelizeYMMSelectorData(resp);
    if (!data.length) {
      console.error("Something wrong in YMM queries");
      return;
    }
    const fieldName = this.name;
    const selectedValue = localStorage.getItem(`ymm-${fieldName}`);
    const initOption = `<option value="">${this.dataset.label}</option>`;
    const initValue = this.value;
    if (fieldName == "year") {
      data = [...new Set(data)];
      data.sort((a, b) => {
        return +b.value - +a.value;
      });
    }
    const options = data.map((item) => {
      const option = document.createElement("option");
      option.value = item.value;
      option.innerHTML = item.value;
      option.selected = item.value == selectedValue;
      return option.outerHTML;
    });
    const html = [.../* @__PURE__ */ new Set([initOption, ...options])].join("");
    this.closest("ymm-component").querySelectorAll(`.jsYMMSelect[name=${fieldName}]`).forEach((item) => {
      item.innerHTML = "";
      item.innerHTML = html;
      item.removeAttribute("disabled");
      if (initValue.length) {
        item.value = initValue;
      }
      item.classList.remove("loading");
    });
  }
  async function callGarage(config) {
    const query = JSON.parse(config).query;
    const array = query.split(",").filter(Boolean);
    const str = {
      "metafields": [
        {
          "namespace": "custom",
          "key": "garage",
          "value": JSON.stringify(array),
          "type": "list.single_line_text_field"
        }
      ]
    };
    const body = JSON.stringify(str);
    try {
      const response = await fetch("/apps/toolbox/api/customers/metafields", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error calling garage API:", error);
    }
  }
  function setYMMFilterResult(hits, templateHTML, searchParams = null, ymmSelected) {
    let html = "";
    hits.hits.forEach(({ _source }) => {
      let temp = templateHTML;
      const { title, handle, images: [image], variants, metafields } = _source;
      const { reviews_rating, reviews_rating_count, boost_tagline, boost_clp_promo } = metafields;
      const priceList = variants.map((i) => i.price);
      priceList.sort((a, b) => {
        return a < b;
      });
      const price = priceList[0] || 0;
      let review = 0;
      let reviewCount = 0;
      if (reviews_rating) {
        reviewCount = Math.round(+reviews_rating_count.value);
        review = JSON.parse(reviews_rating.value).value;
      }
      [
        {
          key: "title",
          value: title
        },
        {
          key: "handle",
          value: handle
        },
        {
          key: "price",
          value: price
        },
        {
          key: "fitment",
          value: ymmSelected || ""
        }
      ].forEach((item) => {
        const regex = `[${item.key}]`;
        temp = temp.replaceAll(regex, item.value);
      });
      html += temp;
    });
    return html;
  }
  function getYMMFilterQueries(aggOptions = null) {
    const { sortElement, ymmSelectors, config: { size = 24, page = 0 } } = this;
    const ymmsLevel = this?.config?.ymmsLevel || "ymms";
    const ymmParams = getYMMValues.call(this);
    const filterParams = getYMMFilters.call(this);
    const sortParams = getSortQuery.call(this);
    const from = page * size;
    const should = [];
    const must = [];
    const must_not = [
      {
        term: {
          combinedListingRole: {
            value: "CHILD"
          }
        }
      }
    ];
    const matchesProducts = [];
    const matchesVariants = [];
    let params = new URLSearchParams(window.location.search);
    const keys = ["vehicle_type", "year", "make", "model"];
    const ymmShoulds = [];
    for (const key of keys) {
      if (params.get(key)) {
        matchesProducts.push({
          match: {
            [`ymms.${key}`]: params.get(key)
          }
        });
        matchesVariants.push({
          match: {
            [`variants.ymms.${key}`]: params.get(key)
          }
        });
      }
    }
    if (matchesProducts.length > 0) {
      ymmShoulds.push({
        nested: {
          path: "ymms",
          query: {
            bool: {
              must: matchesProducts
            }
          }
        }
      });
    }
    if (matchesVariants.length > 0) {
      ymmShoulds.push({
        nested: {
          path: "variants.ymms",
          query: {
            bool: {
              must: matchesVariants
            }
          }
        }
      });
    }
    if (ymmShoulds.length > 0) {
      should.push({
        bool: {
          minimum_should_match: 1,
          should: ymmShoulds
        }
      });
    }
    const isSelectingYMM = aggOptions?.nextYMMName != null;
    const hasVehicleSpecificFitmentSelected = filterParams.fitments.includes("Ride Specific");
    const hasUniversalFitmentSelected = filterParams.fitments.includes("Universal");
    if (isSelectingYMM || hasVehicleSpecificFitmentSelected) {
      ymmParams ? should.push(ymmParams) : should.push({
        nested: {
          path: "metafields.custom_universal_specific",
          query: {
            bool: {
              must: { match: { "metafields.custom_universal_specific.value": "Ride Specific" } }
            }
          }
        }
      });
    }
    if (!isSelectingYMM) {
      if (hasUniversalFitmentSelected) {
        should.push({
          nested: {
            path: "metafields.custom_universal_specific",
            query: {
              bool: {
                must: { match: { "metafields.custom_universal_specific.value": "Universal" } }
              }
            }
          }
        });
      }
    }
    for (const [optionName, optionValues] of Object.entries(filterParams.productMetafields)) {
      must.push({
        nested: {
          path: "metafields." + optionName,
          query: {
            bool: {
              must: [
                {
                  terms: {
                    [`metafields.${optionName}.value`]: optionValues
                  }
                }
              ]
              // optionValues.map(item => {
              //   return {
              //     match: {
              //       [`metafields.${optionName}.value`]: item
              //     }
              //   }
              // }),
            }
          }
        }
      });
    }
    if (!isSelectingYMM) {
      const collectionId = this.config.collection.id;
      if (collectionId != null && collectionId !== "") {
        must.push({
          nested: {
            path: "collections",
            query: {
              bool: {
                must: [
                  { match: { "collections.id": this.config.collection.id } }
                ]
              }
            }
          }
        });
      }
      for (const [optionName, optionValues] of Object.entries(filterParams.variantsSelectedOptions)) {
        must.push({
          nested: {
            path: "variants.selectedOptions",
            query: {
              bool: {
                must: [
                  { term: { "variants.selectedOptions.name": optionName } },
                  { terms: { "variants.selectedOptions.value": optionValues } }
                ]
              }
            }
          }
        });
      }
      ;
      for (const [optionName, optionValues] of Object.entries(filterParams.variantMetafieldOptions)) {
        must.push({
          nested: {
            path: "variants.metafields." + optionName,
            query: {
              bool: {
                must: [
                  {
                    terms: {
                      [`variants.metafields.${optionName}.value`]: optionValues
                    }
                  }
                ]
              }
            }
          }
        });
      }
      if (filterParams.variantsPrice?.lte != null || filterParams.variantsPrice?.gte != null) {
        must.push({
          nested: {
            path: "variants",
            query: {
              bool: {
                must: [
                  { range: { "variants.price": filterParams.variantsPrice } }
                ]
              }
            }
          }
        });
      }
      if (filterParams.productTypes.length > 0) {
        must.push({
          terms: { productType: filterParams.productTypes }
        });
      }
      if (filterParams.vendor.length > 0) {
        must.push({
          terms: { vendor: filterParams.vendor }
        });
      }
    }
    for (const [optionName, optionValues] of Object.entries(filterParams.mustNotIncludes)) {
      must_not.push({
        nested: {
          path: "metafields." + optionName,
          query: {
            bool: {
              must: [
                {
                  terms: {
                    [`metafields.${optionName}.value`]: optionValues
                  }
                }
              ]
            }
          }
        }
      });
    }
    const query = {
      bool: {
        should,
        minimum_should_match: should.length === 0 ? void 0 : 1,
        must,
        must_not
      }
    };
    const aggs = {};
    if (aggOptions?.include || true) {
      aggs["variants"] = {
        nested: {
          path: "variants"
        },
        aggs: {
          available_ranges: {
            range: {
              field: "variants.inventoryQuantity",
              ranges: [
                { to: 1, key: "Out of stock" },
                { from: 1, key: "In stock" }
              ]
            }
          },
          min_price: { min: { field: "variants.price" } },
          max_price: { max: { field: "variants.price" } }
        }
      };
      const addMetafield = (filterOptionName) => {
        aggs[filterOptionName] = {
          nested: {
            path: "metafields." + filterOptionName
          },
          aggs: {
            all_values: {
              terms: {
                field: "metafields." + filterOptionName + ".value",
                size: ELASTICSEARCH_ALL_VALUES_TERMS_SIZE
              }
            }
          }
        };
      };
      addMetafield("custom_universal_specific");
      for (const el of document.querySelectorAll('[data-filter-type="product_variant"]')) {
        const { filterOptionName } = el.dataset;
        addMetafield(filterOptionName);
      }
      for (const el of document.querySelectorAll('[data-filter-type="variant_option"]')) {
        const { filterOptionName } = el.dataset;
        aggs[filterOptionName] = {
          nested: {
            path: "variants.selectedOptions"
          },
          aggs: {
            all_values: {
              filter: {
                term: { "variants.selectedOptions.name": filterOptionName }
              },
              aggs: {
                all_possible_values: {
                  terms: { field: "variants.selectedOptions.value", size: ELASTICSEARCH_ALL_VALUES_TERMS_SIZE }
                }
              }
            }
          }
        };
      }
      for (const el of document.querySelectorAll('[data-filter-type="variant_metafield"]')) {
        const { filterOptionName } = el.dataset;
        aggs[filterOptionName] = {
          nested: {
            path: "variants.metafields." + filterOptionName
          },
          aggs: {
            all_values: {
              terms: {
                field: `variants.metafields.${filterOptionName}.value`,
                size: ELASTICSEARCH_ALL_VALUES_TERMS_SIZE
              }
            }
          }
        };
      }
      aggs["product_types"] = {
        terms: { field: "productType", size: 50 }
      };
      aggs["product_vendors"] = {
        terms: { field: "vendor", size: 50 }
      };
      if (isSelectingYMM) {
        aggs["ymm_values"] = {
          nested: {
            path: ymmsLevel
          },
          aggs: {
            all_values: {
              terms: { field: `${ymmsLevel}.${aggOptions.nextYMMName}`, size: ELASTICSEARCH_ALL_VALUES_TERMS_SIZE }
            }
          }
        };
      }
    }
    return {
      _source: {
        exclude: [
          // "ymms.*",
          // "variants.ymms.*"
        ]
      },
      from,
      size: aggOptions?.noResults ? 0 : size,
      query,
      aggs,
      sort: sortParams
    };
    function getSortQuery() {
      const sort = [];
      const sortElement2 = document.querySelector('[name="ymm_sort"] option:checked');
      const collectionDefaultSortBy = document.getElementById("ymm-collection-info")?.dataset.collectionDefaultSortBy;
      if (!sortElement2)
        return void 0;
      const type = sortElement2.value;
      const order = type.includes("ascending") ? "asc" : "desc";
      const collectionId = this.config.collection.id;
      if (type.includes("price")) {
        sort.push({
          "variants.price": {
            mode: "avg",
            order,
            nested: {
              path: "variants"
            }
          }
        });
        return sort;
      } else if (type.includes("title")) {
        sort.push({ title: { order } });
        return sort;
      } else if (type.includes("created")) {
        sort.push({ createdAt: { order } });
        return sort;
      } else if (type.includes("manual") && collectionId != null && collectionId !== "") {
        sort.push({
          "collections.sort": {
            order: "asc",
            nested: {
              path: "collections",
              filter: {
                term: {
                  "collections.id": collectionId
                }
              }
            }
          }
        });
        return sort;
      }
      return sort;
    }
    function getYMMFilters() {
      const mustNotIncludes = {};
      const variantsSelectedOptions = {};
      const variantMetafieldOptions = {};
      const productMetafields = {};
      const variantsPrice = {};
      const fitments = [];
      const productTypes = [];
      const vendor = [];
      for (const el of document.querySelectorAll(".jsYMMParams")) {
        let filterType, filterOptionName;
        if (el.closest("[data-filter-type]")) {
          filterType = el.closest("[data-filter-type]").getAttribute("data-filter-type");
          filterOptionName = el.closest("[data-filter-type]").getAttribute("data-filter-option-name");
        } else {
          filterType = el.getAttribute("data-filter-type");
          filterOptionName = el.getAttribute("data-filter-option-name");
        }
        switch (filterType) {
          case "variant_option":
            (el.type == "hidden" || el.checked) && addOptionValues(filterOptionName, el.value, variantsSelectedOptions);
            break;
          case "variant_metafield":
            (el.type == "hidden" || el.checked) && addOptionValues(filterOptionName, el.value, variantMetafieldOptions);
            break;
          case "product_variant":
            (el.type == "hidden" || el.checked) && addOptionValues(filterOptionName, el.value, productMetafields);
            break;
          case "fitment":
            (el.type == "hidden" || el.checked) && fitments.push(el.value);
            break;
          case "product_type":
            (el.type == "hidden" || el.checked) && productTypes.push(el.value);
            break;
          case "product_vendor":
            (el.type == "hidden" || el.checked) && vendor.push(el.value);
            break;
          case "variant_price":
            const { name, value } = el;
            let n = name === "gte" ? 0 : void 0;
            if (value.trim() !== "") {
              const v = Number(value);
              const bound = Number(name === "gte" ? el.getAttribute("min") : el.getAttribute("max"));
              if (!floatEqual(v, bound)) {
                n = v;
              }
            }
            variantsPrice[el.name] = n;
            break;
          default:
            console.error("Unhandled filter element", el);
        }
      }
      Array.from(document.querySelectorAll("[data-filter-type][data-must-not]")).forEach((item) => {
        const { filterType, filterOptionName, hiddenValues } = item.dataset;
        if (!hiddenValues)
          return;
        hiddenValues.split(",").filter(Boolean).forEach((value) => {
          addOptionValues(filterOptionName, value, mustNotIncludes);
        });
      });
      return { variantsSelectedOptions, variantMetafieldOptions, variantsPrice, fitments, productTypes, vendor, productMetafields, mustNotIncludes };
      function addOptionValues(key, value, object) {
        const selectedOptions = object[key] ?? [];
        if (!selectedOptions.includes(value)) {
          selectedOptions.push(value);
        }
        object[key] = selectedOptions;
      }
    }
    function getYMMValues() {
      const arr = YMM_LEVELS.map((item) => {
        const must2 = ymmSelectors.filter((i) => i.value).map((ymm) => ({
          match: {
            [`${item.field}.${ymm.name}`]: ymm.value
          }
        }));
        return must2.length ? {
          nested: {
            path: item.field,
            query: {
              bool: { must: must2 }
            }
          }
        } : null;
      }).filter(Boolean);
      return arr.length ? {
        bool: {
          minimum_should_match: 1,
          should: arr
        }
      } : void 0;
    }
    function getYMMFilterParams() {
      const shouldQueries = [];
      const mustQueries = [];
      document.querySelectorAll("ymm-filter").forEach((item) => {
        const array = item.getFilterParams;
        if (!array)
          return;
        if (item.classList.contains("jsYMMShould"))
          shouldQueries.push(array);
        else
          mustQueries.push(array);
      });
      return {
        should: shouldQueries,
        must: mustQueries
      };
    }
  }
  function floatEqual(a, b) {
    return Math.abs(parseInt(a) - parseInt(b)) < 1e-3;
  }
  function containsVehicleSpecific(obj, keyToFind = null, valueToFind = null) {
    if (!keyToFind || !valueToFind)
      return false;
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (key === keyToFind) {
          if (typeof value === "string" && value === valueToFind) {
            return true;
          } else if (Array.isArray(value)) {
            if (value.includes(valueToFind)) {
              return true;
            }
          } else if (typeof value === "object" && value !== null) {
            if (Object.values(value).includes(valueToFind)) {
              return true;
            }
          }
        }
        if (typeof value === "object" && value !== null) {
          const found = containsVehicleSpecific(value, keyToFind, valueToFind);
          if (found)
            return true;
        }
      }
    }
    return false;
  }

  // app/scripts/common/function/handleizeYMM.js
  var CONSTANT = {
    YMMs: ["vehicle_type", "year", "make", "model"]
  };
  function handleizeData(data) {
    if (!data)
      return void 0;
    const query = new URLSearchParams();
    const searchParams = new URLSearchParams(data);
    const vehicleParts = [...searchParams.entries()].filter(([key, value]) => {
      return CONSTANT.YMMs.includes(key);
    }).map(([key, value]) => {
      query.set(key, value);
      return { key, value: decodeURIComponent(value) };
    });
    const vehicleName = vehicleParts.map(({ value }) => value).join(" ");
    const shopUrl = vehicleParts.map(({ key, value }) => {
      return `${key}=${encodeURIComponent(value)}`;
    }).join("&");
    return {
      vehicleName,
      shopUrl,
      query: query.toString(),
      parts: vehicleParts
    };
    function removeWord(text, wordToRemove) {
      const regex = new RegExp(`\\b${wordToRemove}\\b`, "gi");
      return text.replace(regex, "").trim();
    }
  }

  // app/scripts/ymm-helpers.js
  window.YMM_HELPERS = {
    ...window.YMM_HELPERS,
    cookie,
    ymmFetch,
    getYMMSelectorQueries,
    setYMMSelectorValues,
    getYMMFilterQueries,
    setYMMFilterResult,
    getFitmentTableData,
    containsVehicleSpecific,
    floatEqual,
    callGarage,
    handleizeData
  };
})();
